import axios from "axios";

export const baseUrl = "https://subscribe-d2g.rashigames.com/";

export const getServiceDetailsApi = async () => {
    // const response = await axios.get(`${baseUrl}api/v1/get-service-details`);
    const response = await axios.get(`https://api.payment-app.info/grameenphone/billing/products_by_name?name=Door2Games`);
    return response;
}

export const subscriptionRedirectApi = async (data) => {
    // const response = await axios.post(`${baseUrl}api/v1/subscription-redirect`,data);
    const response = await axios.post(`https://api.payment-app.info/grameenphone/checkout/create-checkout-session/Door2Games`, data);
    return response;
}

export const printLogsApi = async (data) => {
    const response = await axios.post(`${baseUrl}api/v1/print-logs`, data);
    return response;
}

export const loginApi = async (data) => {
    const response = await axios.post(`${baseUrl}api/v1/login`, data);
    return response;
}